import React from "react";
import posterImage from '../../images/morph-thumb.jpg';


const JoinVideo = ({ data }) => {
  return (
    <section className="pt-lg-16 pb-lg-16 pb-11 pt-11">
      <div className="container">
        <div className="row">
          {/* First Feature Block */}
          <div className="col-lg-5 col-md-12">
            <div className="feature-card">
              <div className="d-flex mb-6">
                <span className="zg-label bg-yellow text-black me-2">06</span>
                <span className="zg-label bg-yellow text-black">Join</span>
              </div>
              <h2 className="h3 mb-6 rm-title">
                The fastest growing DAO for Bitcoin Builders
              </h2>
              <div className="col-12 col-md-12 text-center text-lg-start mb-6 hidden-desktop vdo-border m-0">
              <div className="video-wrapper">
              <video
                controls
                muted
                preload="metadata"
                autoPlay
                loop
              >
                <source src="/video/morph-collective-new.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
              </div>
              <p className="mb-6 rm-md-text">
                Join RootstockCollective to access funding opportunities and to
                grow your project, become an active builder and create added
                value on Rootstock while getting rewarded.
              </p>
              <a
                href="https://rootstockcollective.xyz/"
                className="btn-outline-white btn-lg btn"
                rel="noopener noreferrer"
                target="_blank"
              >
                Learn More
              </a>
            </div>
          </div>

          {/* Second Feature Block */}
          <div className="col-lg-6 offset-lg-1 col-md-12 mt-5 hidden-mobile">
            <div className="feature-card mt-5">
              <div className="col-12 col-md-12 text-center text-lg-start vdo-border m-0">
              <div className="video-wrapper">
                <video
                  controls
                  muted
                  preload="metadata"
                  autoPlay
                  loop
                >
                  <source src="/video/morph-collective-new.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinVideo;
